import { SelectionType } from "../enum";
export const MarketIdToMarketType = {
    "1_0": SelectionType.ML,
    "2_0": SelectionType.HC,
    "3_0": SelectionType.OU,
    "1_39": SelectionType.ML,
    "2_39": SelectionType.HC,
    "3_39": SelectionType.OU,
    "1_2165": SelectionType.TQ,
    "1_169": SelectionType.MLET,
    "3_1697": SelectionType.TGET,
    1707: SelectionType.PW,
};
//# sourceMappingURL=MarketIdToMarketType.js.map